<template>
  <div class="main-container">
    <div id="chart-container-main"></div>
    <div
      v-if="!showBtn"
      class="d-flex align-center justify-center"
    >
      <br><br><br><br><br><br>
      <span v-if="noData">No Chart</span>
      <FullLoading :loading="loadingOrgchart" style="margin-top: 25vh;"/>
    </div>
    <v-container fluid>
      <v-layout column class="fab-container">
        <v-card
          v-show="!loadingOrgchart"
          outlined
          width="auto"
          height="30"
          :style="`border: 1px solid #C7C7C7; position: fixed; top: ${scrollPosition>90? 117:$vuetify.breakpoint.name == 'xs'? 245-scrollPosition:235-scrollPosition}px; right: 22px;`"
        >
          <v-btn
            id="zoomOut-main"
            icon
            tile
            small
            color="#999999"
            v-show="!loading"
            :dark="!percent==25"
            :disabled="percent==25"
          >
            <v-icon dark>
              mdi-minus
            </v-icon>
          </v-btn>
          <v-btn
          class="ma-0 pa-0"
            tile
            small
            text
            disabled
            color="#999999"
            v-show="!loading"
          >
            {{ percent }}%
          </v-btn>
          <v-btn
            id="zoomIn-main"
            icon
            tile
            small
            color="#999999"
            v-show="!loading"
            :dark="!percent==175"
            :disabled="percent==175"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
        </v-card>
        <v-row>
          <v-btn
            id="btn-export"
            class="mx-2 mr-10 mb-10 white--text"
            :style="`margin-top: ${scrollPosition>90? 85:$vuetify.breakpoint.name == 'xs'? 210-scrollPosition:200-scrollPosition}px;`"
            fixed
            color="#2BA197"
            elevation="0"
            @click="saveChartToPNG"
            v-show="showBtn"
            :disabled="!canExport"
          >
          <img width="16" height="16" class="mr-2 mt-1" src="@/assets/icons/tray-arrow-down.png"/>
          ดาวน์โหลด
          </v-btn>
        </v-row>
    </v-layout>
    </v-container>
    <OverlayLoading :loading="loading"/>
    <v-dialog
      persistent
      v-model="dialog"
      width="100%"
      height="100%"
    >
      <!-- <OrgchartPanal :resource="this.dialogResource"/> -->
    </v-dialog>
  </div>
</template>
<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/es6-promise/4.1.1/es6-promise.auto.min.js"></script>
<script type="text/javascript" src="js/jquery.min.js"></script>
<script>
import $ from 'jquery'
import OrgchartPanal from './_orgchartPanal.vue'
import FullLoading from '../_template/FullLoading.vue'
import OverlayLoading from '../_template/OverlayLoading.vue'
import { EventBus } from '@/EventBus'
import { fetchMainOrgchart, generateBase64Image } from '@/API/API'
const axios = require('axios')
const html2canvas = require('html2canvas')
const FileSaver = require('file-saver')
const wrap = require('word-wrap')

export default {
  props: {
    groupCompanyUID: String
  },
  components: {
    FullLoading,
    OverlayLoading,
    OrgchartPanal
  },
  name: 'tree',
  data () {
    return {
      scrollPosition: 0,
      offset: 128,
      offsetTop: 0,
      dialog: false,
      showBtn: false,
      zoomval: 0,
      img64Array: [],
      zoomCount: 0,
      canExport: true,
      loading: false,
      loadingOrgchart: false,
      loadingExport: false,
      noData: false,
      percent: 100
    }
  },
  watched: {
    groupCompanyUID: function(newVal, oldVal) { // watch it
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.updateScroll)
    var self = this
    EventBus.$on('hideNavbarDone', function () {
       setTimeout( () => {
        self.offset = 0
      }, 2000)
    })
  },
  computed: {
  },
  async created () {
    this.getChartData()
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    async getChartData () {
      let result = []
      let self = this
      self.showBtn = false
      self.loadingOrgchart = true
      self.noData = false
      let payload = {
         groupCompanyId: this.groupCompanyUID
      }
      try {
        const res = await fetchMainOrgchart(payload, self.$store.state.token)
        if (res.success) {
          result = res.result
          await self.modifyKeys(result)
          self.showBtn = true
        } else {
          self.showBtn = false
          self.noData = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        await self.createChart(result)
        self.loadingOrgchart = false
      }
    },
    async createChart (data) {
      var self = this
      var nodeTemplateMain = function(datasource) {
      if (datasource.img64 === 'data:image/jpeg;base64,') {
          datasource.img64 = '/img/icons/noname.jpg'
        }
        let cssProfileImage = `
        width: 65.4px;
        height: 65.4px;
        max-width: 65.4px !important;
        object-fit: cover;
        border-radius: 50%;
        border : solid;
        border-color: #D3D3D3;
        border-width: thin;
        object-fit: contain;
        `
        let cssNode = `
        text-align: center;
        justify-content: center;
        align-items: center;
        padding: 8px 8px 12px;
        min-width: 250px;
        background: #FFFFFF;
        border: 2px solid #C7C7C7;
        box-sizing: border-box;
        border-radius: 4px;
        `
        let imagUI = datasource.img==undefined? ``:`<img src="${datasource.img64}" style="${cssProfileImage}"/>`

        let partTitle = `
          <p style="
            margin-top: 5px;
            margin-bottom: 5px;
            font-family: Sarabun;
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 22px;
            text-align: center;
            color: #333333;
          ">${datasource.title||''}</p>
        `
        let partName = `
          <p style="
            margin-top: 10px;
            margin-bottom: 5px;
            font-family: Sarabun;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 22px;
            text-align: center;
            color: #333333;
          ">${datasource.name||''}</p>
        `

        return `
        <div style="
        ${cssNode}
        ">
          <div class="custom-user">
            ${imagUI}
            ${datasource.title? partTitle:''}
            ${datasource.name? partName:''}
          </div>
        </div>
        `
    };

    var ocMain = $('#chart-container-main').orgchart({
      chartClass: 'chart-container-main',
      data : data,
      nodeTitle: 'name',
      // nodeContent: 'title',
      // nodeId: 'id',
      // parentNodeSymbol: 'pid',
      verticalLevel: 3,
      // visibleLevel: 6,
      // 'direction': 'b2t',
      // 'direction': 'l2r',
      // 'depth': 1,
      // 'verticalDepth': 3,
      pan: true,
      zoom: false,
      zoominLimit: 3,
      // zoomoutLimit: 1,
      draggable: false,
      parentNodeSymbol: 'fa-users',
      // 'toggleSiblingsResp': true,
      // toggleSiblingsResp: false,
      nodeTemplate: nodeTemplateMain,
      exportButton: false,
      exportFilename: 'orgchart',
      exportFileextension: 'png',
      'initCompleted': function(){
        setTimeout( function(){
          // center the chart to container
          var $container = $('#chart-container-main');
          var $chart = $('.orgchart');
          $chart.addClass('noncollapsable'); // deactivate
          $chart.css('transform', "scale(1,1)");
          var zoomval = 0.6295000000000002
          var zoomCount = 0;
          var currentZoom = zoomval
          self.percent = 100
          var offsetTop = 0
          self.offsetTop = offsetTop
          $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${0}) scale(${zoomval}, ${zoomval})`)
          // zoom buttons
          $('#zoomIn-main').on('click', function () {
            if (zoomCount <= 2) {
              self.percent+=25
              zoomCount++
              zoomval = currentZoom += 0.1235;
              // offsetTop-=(($chart[0].scrollHeight - $chart.height())*Math.abs(zoomCount))
              self.offsetTop = offsetTop
              $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-offsetTop}) scale(${zoomval}, ${zoomval})`)
            }
          });
          $('#zoomOut-main').on('click', function () {
            if (zoomCount >= -3) {
              self.percent-=25
              zoomCount--
              zoomval = currentZoom -= 0.1235;
              if (zoomval.toFixed(1) < 1 ) {
              // offsetTop+=(($chart[0].scrollHeight - $chart.height())*Math.abs(zoomCount))
              self.offsetTop = offsetTop
              $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-offsetTop}) scale(${zoomval}, ${zoomval})`)
              }
            }
          });

        }  , 10 );
      },
    });
    },
    async hideNavbar () {
      EventBus.$emit('hideNavbar')
    },
    async modifyKeys(obj){
      for (var key in obj) {
        if (obj[key]!==null) {
          if (key == 'base64' && obj['base64']!=='') {
            // obj['img'] = 'uploads/62149.jpg'
            // let img64 = await this.getBase64Profile(obj['img'], obj['email'])
            // obj['img64'] = 'data:image/jpeg;base64,' + img64.toString()
            obj['img64'] = 'data:image/jpeg;base64,' + obj['base64'].toString()
          }
          if (key == 'name' && obj['name']!==null) {
            obj['name'] = wrap(obj['name'].trim(), {width: 27, newline: '<br>'})
          }
          if (key == 'title' && obj['title']!==null) {
            obj['title'] = wrap(obj['title'].trim(), {width: 23, newline: '<br>'})
          }
          if(typeof obj[key] == 'object'){
            await this.modifyKeys(obj[key])
          }
        }
      }
    },
    async getBase64Image (filePath) {
      let result = [{'base64':''}]
      let self = this
      let obj = {
        "listPart": [
          { "img": filePath }
        ]
      }
      // if (!self.loadingOrgchart) self.loadingOrgchart = true

      try {
        const res = await generateBase64Image(self.$store.state.token, obj)
        // console.log(res)
        if (res.success) {
          result = res.result[0].base64
        } else result = ''
      } catch (error) {
        // console.log(error)
        result = ''
      } finally {
        // self.loadingOrgchart = false
      }
      return result
    },
    async resizeBeforeExport () {
      let self = this
      let $container = $('#chart-container-main');
      let $chart = $('.orgchart');
      // console.log($chart.height())
      let div = $chart.css('transform');
      let zoomval = 0.4 - (0.039*($chart.width()/$container.width()))
      let offsetTop = $chart.height() > 2000? self.offsetTop + (($chart[0].scrollHeight - $chart.height())*Math.abs(3))*3:self.offsetTop
      $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-offsetTop}) scale(${zoomval}, ${zoomval})`)
    },
    async saveChartToPNG () {
      var self = this
      self.canExport = false
      self.loading = true
      await this.hideNavbar()
      setTimeout( () => {
        this.resizeBeforeExport()
      }, 1000)
      let element = document.querySelector("#chart-container-main")
      let zoomval_origin = 0.5
      let $container = $('#chart-container-main');
      let $chart = $('.orgchart');
      setTimeout( () => {
          html2canvas(
          element,
          {
            allowTaint: false,
            useCORS: false,
            foreignObjectRendering: false,
            scale: 4,
          }
          ).then(canvas => {
            canvas.toBlob(function(blob) {
              FileSaver.saveAs(blob, "main-orgchart.png");
              self.canExport = true
              self.loading = false
              $chart.css('transform', `matrix(1, 0, 0, 1, ${-(($chart[0].scrollWidth - $container.width())/2)}, ${-($container[0].scrollHeight - $container.height())/2}) scale(${zoomval_origin}, ${zoomval_origin})`)
          })
        })
      }, 1000)
    },
    getDetailCompanyMain (nodeId) {
      EventBus.$emit('detailCompany', nodeId)
    },
    async getCompanyList () {
      var self = this
      await this.axios({
        method: 'get',
        url: `${this.api}/api/v1/companys/list`
      })
        .then(function (response) {
          self.itemsCompanyMain = response.data.result
        }).catch(function (err) {
          console.log(err)
        })
    },
    async getCompanyNode () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/v1/companys/node`,
        headers: {
          authorization: 'Bearer 965a322e60b0517f59976d7634bc45f240ea54a57d5a665e94767e43134e1cbf'
        }
      }).then((response) => {
        this.node = response.data.node
      }).catch(e => {
        // console.log(e)
      })
    },
    getDetailCompany (nodeId) {
      this.nodeId = nodeId
      this.nodeData = this.chart.get(nodeId)
      this.dialogEditMain = true
      this.companyNameMainEdit = this.nodeData.name
      this.companyIdEdit = this.nodeData.pid
      // this.editCompany(this.nodeId, this.companyNameMainEdit, this.companyPidEdit)
    },
    async editCompany (companyIdEdit, companyNameMainEdit) {
      await this.axios({
        method: 'put',
        url: `${this.api}/api/v1/companys/` + this.nodeId,
        data: {
          companyName: companyNameMainEdit,
          companyPid: companyIdEdit
        }
      }).then((response) => {
        this.nodeId = ''
        this.companyNameMainEdit = ''
        this.companyIdEdit = ''
        this.dialogEditMain = false
        this.getCompanyNode()
      }).catch(e => {
        // console.log(e)
      })
    },
    confirmDeleteCompany (nodeId) {
      // console.log('Confirm delete')
      this.nodeData = this.chart.get(nodeId)
      swal({
        title: 'Confirm to Delete?',
        text: 'Company Name: ' + this.nodeData.name,
        icon: 'warning',
        buttons: {
          confirm: 'Confirm',
          cancel: 'Cancel'
        }
      }).then(function (isConfirm) {
        if (isConfirm) {
          // console.log('Confirm', isConfirm)
          this.deleteCompany(nodeId)
        } else {
          // console.log('Cancel')
        }
      })
    },
    async deleteCompany (nodeId) {
      this.nodeData = this.chart.get(nodeId)
      // console.log('DElete')
      // console.log('Delete', this.nodeData.allChildren)
      // console.log('Root', this.chart)
      // console.log('Chart', this.chart.roots[0].children)
      // if (this.chart.roots[0].children.length > 0) {
      //   console.log('ลบไม่ได้', this.chart.roots[0].children.length)
      // } else {
      //   console.log('ลบได้', this.chart.roots[0].children.length)
      // }
      await this.axios({
        method: 'post',
        url: `${this.api}/api/v1/charts/delete/chartByCompany`,
        data: {
          companyId: nodeId
        }
      }).then((response) => {
        swal('Success', 'Delete Company Success', 'success')
        this.getCompanyNode()
      }).catch(e => {
        // console.log(e)
        swal('Error', 'Delete Company Fail', 'error')
      })
    },
    async addComMain (companyId, companyNameMain) {
      // console.log('Add', companyId)
      // if (this.companyNameMain !== '') {
      //   this.ocMain(this.$refs.tree, this.node)
      //   document.getElementById('orgShow').style.display = 'block'
      //   document.getElementById('btnSaveChart').style.display = 'block'
      //   document.getElementById('createShow').style.display = 'none'

      //   this.chart.load([
      //     { id: 1, companyPid: '', companyName: `${this.companyNameMain}`, title: 'CEO', img: 'https://cdn.balkan.app/shared/11.jpg' }
      //   ])
      // } else if (this.companyNameMain === '') {
      //   document.getElementById('orgShow').style.display = 'none'
      //   document.getElementById('btnSaveChart').style.display = 'none'
      //   document.getElementById('createShow').style.display = 'block'
      // }
      // if (this.chkMainCompany === true) {
      //   this.companyId = ''
      // } else {
      //   this.companyId = companyId
      // }
      await this.axios({
        method: 'post',
        url: `${this.api}/api/v1/companys`,
        data: {
          companyName: companyNameMain,
          companyPid: companyId
        }
      }).then((response) => {
        swal('Success', 'Create Company Success', 'success')
        this.getCompanyNode()
        // console.log('All Data', this.chart.config.nodes)
        this.dialogCreatMain = false
      }).catch(e => {
        // console.log(e)
        swal('Error', 'Create Company Fail', 'error')
      })
    },
    async saveChart () {
      // console.log('Save Chart', this.chart.config)
    }
  }
}
</script>
<style lang="scss">

.float{
  position:fixed;
  width:60px;
  height:60px;
  bottom:140px;
  right:140px;
  margin-top: 204px;
  margin-left: -200px;
}

#zoomIn-main {
  // right: 135px;
}
#zoomOut-main {
  // right: 90px;
}

#btn-export{
  right: -18px;
  top: -18px;
}

.chart-container-main {
  // margin: 0px;
  // position: relative;
  // display: inline-block;
  // height: 800px;
  // height: calc(100% - 24px);
  // width: calc(100% - 24px);
  // border: 2px dashed #aaa;
  // border-radius: 5px;
  // overflow: none;
  // text-align: center;
  // transform: scale(0.8);
  // transform: scale(0.24);
  // transform-origin: 0 0;
}

.chart-menu {
    border-width: 10px !important;
    border-color: #aeaeae !important;
    border: 1px solid #aeaeae !important
  }
  [data-item] {
    border-width: 0px !important;
    padding: 10px !important;
  }
  [data-tlbr] {
    margin: 20px !important;
  }
  [data-tlbr="layout"] {
      transform: rotate(0deg) translateX(0px) translateY(0px) !important;
  }
  .shadow {
    -webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .25));
    filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .25));
  }
  /* [node-id] rect {
    fill: #CAE3CC;
  } */
  text {
  font-family: 'Sarabun', sans-serif !important;
  /* font-weight: bold; */
  font-size: 28px;
}

.org-chart {
  display: flex;
  justify-content: center;
  ul {
    padding-top: 20px;
    position: relative;
    transition: all 0.5s;
    ul::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      border-left: 1px solid #ccc;
      /* // width: 0;
      //height: 20px; */
    }
  }
  li {
    float: left;
    text-align: center;
    list-style-type: none;
    position: relative;
    padding: 10px 10px 10px 10px;
    transition: all 0.5s;
  }
}

.orgchart ~ .mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
.orgchart ~ .mask .spinner {
  position: absolute;
  top: calc(50% - 54px);
  left: calc(50% - 54px);
  color: rgba(255, 255, 255, 0.8);
  font-size: 108px;
}
.orgchart .node {
  transition: transform 0.3s, opacity 0.3s;
}
.orgchart .slide-down {
  opacity: 0;
  transform: translateY(40px);
}
.orgchart.l2r .node.slide-down,
.orgchart.r2l .node.slide-down {
  transform: translateY(130px);
}
.orgchart .slide-up {
  opacity: 0;
  transform: translateY(-40px);
}
.orgchart.l2r .node.slide-up,
.orgchart.r2l .node.slide-up {
  transform: translateY(-130px);
}
.orgchart .slide-right {
  opacity: 0;
  transform: translateX(130px);
}
.orgchart.l2r .node.slide-right,
.orgchart.r2l .node.slide-right {
  transform: translateX(40px);
}
.orgchart .slide-left {
  opacity: 0;
  transform: translateX(-130px);
}
.orgchart.l2r .node.slide-left,
.orgchart.r2l .node.slide-left {
  transform: translateX(-40px);
}

/* // .orgchart { background: #fff; }
// .orgchart td.left, .orgchart td.right, .orgchart td.top { border-color: #aaa; }
// .orgchart td>.down { background-color: #aaa; }
// .orgchart .middle-level .title { background-color: #006699; }
// .orgchart .middle-level .content { border-color: #006699; }
// .orgchart .product-dept .title { background-color: #009933; }
// .orgchart .product-dept .content { border-color: #009933; }
// .orgchart .rd-dept .title { background-color: #993366; }
// .orgchart .rd-dept .content { border-color: #993366; }
// .orgchart .pipeline1 .title { background-color: #996633; }
// .orgchart .pipeline1 .content { border-color: #996633; }
// .orgchart .frontend1 .title { background-color: #cc0066; }
// .orgchart .frontend1 .content { border-color: #cc0066; } */

.orgchart .hidden,
.orgchart ~ .hidden {
  display: none;
}
.orgchart.b2t {
  transform: rotate(180deg);
}
.orgchart.l2r {
  position: absolute;
  transform: rotate(-90deg) rotateY(180deg);
  transform-origin: left top;
}
.orgchart .verticalNodes ul {
  list-style: none;
  margin: 0;
  padding-left: 18px;
  text-align: left;
}
.orgchart .verticalNodes ul:first-child {
  margin-top: 2px;
}
.orgchart .verticalNodes > td::before {
  content: "";
  border: 1px solid rgba(217, 83, 79, 0.8);
}
.orgchart .verticalNodes > td > ul > li:first-child::before {
  box-sizing: border-box;
  top: -4px;
  height: 30px;
  width: calc(50% - 2px);
  border-width: 2px 0 0 2px;
}
.orgchart .verticalNodes ul > li {
  position: relative;
}
.orgchart .verticalNodes ul > li::before,
.orgchart .verticalNodes ul > li::after {
  box-sizing: border-box;
  content: "";
  position: absolute;
  left: -6px;
  border-color: rgba(217, 83, 79, 0.8);
  border-style: solid;
  border-width: 0 0 2px 2px;
}
.orgchart .verticalNodes ul > li::before {
  top: -4px;
  height: 30px;
  width: 11px;
}
.orgchart .verticalNodes ul > li::after {
  top: 1px;
  height: 100%;
}
.orgchart .verticalNodes ul > li:first-child::after {
  box-sizing: border-box;
  top: 24px;
  width: 11px;
  border-width: 2px 0 0 2px;
}
.orgchart .verticalNodes ul > li:last-child::after {
  box-sizing: border-box;
  border-width: 2px 0 0;
}
.orgchart.r2l {
  position: absolute;
  transform: rotate(90deg);
  transform-origin: left top;
}
.orgchart > .spinner {
  font-size: 100px;
  margin-top: 30px;
  color: rgba(68, 157, 68, 0.8);
}
.orgchart table {
  border-spacing: 0;
  border-collapse: separate;
}
.orgchart > table:first-child {
  margin: 20px auto;
}
.orgchart td {
  text-align: center;
  vertical-align: top;
  padding: 0;
}
.orgchart .lines:nth-child(3) td {
  box-sizing: border-box;
  height: 20px;
}
.orgchart .lines .topLine {
  border-top: 2px solid rgba(217, 83, 79, 0.8);
}
.orgchart .lines .rightLine {
  border-right: 1px solid rgba(217, 83, 79, 0.8);
  float: none;
  border-radius: 0;
}
.orgchart .lines .leftLine {
  border-left: 1px solid rgba(217, 83, 79, 0.8);
  float: none;
  border-radius: 0;
}
.orgchart .lines .downLine {
  background-color: rgba(217, 83, 79, 0.8);
  margin: 0 auto;
  height: 20px;
  width: 2px;
  float: none;
}
/* node styling */
.orgchart .node {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 3px;
  border: 2px dashed transparent;
  text-align: center;
  width: auto !important;
}
.orgchart.l2r .node,
.orgchart.r2l .node {
  width: 50px;
  height: 130px;
}
.orgchart .node > .spinner {
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  vertical-align: middle;
  font-size: 30px;
  color: rgba(68, 157, 68, 0.8);
}
.orgchart .node:hover {
  /* background-color: rgba(238, 217, 54, 0.5); */
  background-color: transparent !important;
  transition: 0.5s;
  cursor: default;
  z-index: 20;
}
.orgchart .node.focused {
  /* background-color: rgba(238, 217, 54, 0.5); */
  background-color: transparent !important;
}
.orgchart .ghost-node {
  position: fixed;
  left: -10000px;
  top: -10000px;
}
.orgchart .ghost-node rect {
  fill: #ffffff;
  stroke: #bf0000;
}
.orgchart .node.allowedDrop {
  border-color: rgba(68, 157, 68, 0.9);
}
.orgchart .node .title {
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: rgba(217, 83, 79, 0.8);
  color: #fff;
  border-radius: 4px 4px 0 0;
}
.orgchart.b2t .node .title {
  transform: rotate(-180deg);
  transform-origin: center bottom;
}
.orgchart.l2r .node .title {
  transform: rotate(-90deg) translate(-40px, -40px) rotateY(180deg);
  transform-origin: bottom center;
  width: 120px;
}
.orgchart.r2l .node .title {
  transform: rotate(-90deg) translate(-40px, -40px);
  transform-origin: bottom center;
  width: 120px;
}
.orgchart .node .title .symbol {
  float: left;
  margin-top: 4px;
  margin-left: 2px;
}
.orgchart .node .content {
  box-sizing: border-box;
  width: 100%;
  height: 20px;
  font-size: 11px;
  line-height: 18px;
  border: 1px solid rgba(217, 83, 79, 0.8);
  border-radius: 0 0 4px 4px;
  text-align: center;
  background-color: #fff;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.orgchart.b2t .node .content {
  transform: rotate(180deg);
  transform-origin: center top;
}
.orgchart.l2r .node .content {
  transform: rotate(-90deg) translate(-40px, -40px) rotateY(180deg);
  transform-origin: top center;
  width: 120px;
}
.orgchart.r2l .node .content {
  transform: rotate(-90deg) translate(-40px, -40px);
  transform-origin: top center;
  width: 120px;
}
.orgchart .node .edge {
  font-size: 15px;
  position: absolute;
  color: rgba(68, 157, 68, 0.5);
  cursor: default;
  transition: 0.2s;
}
.orgchart.noncollapsable .node .edge {
  display: none;
}
.orgchart .edge:hover {
  color: #449d44;
  cursor: pointer;
}
.orgchart .node .verticalEdge {
  width: calc(100% - 10px);
  width: -webkit-calc(100% - 10px);
  width: -moz-calc(100% - 10px);
  left: 5px;
}
.orgchart .node .topEdge {
  top: -4px;
}
.orgchart .node .bottomEdge {
  bottom: -4px;
}
.orgchart .node .horizontalEdge {
  width: 15px;
  height: calc(100% - 10px);
  height: -webkit-calc(100% - 10px);
  height: -moz-calc(100% - 10px);
  top: 5px;
}
.orgchart .node .rightEdge {
  right: -4px;
}
.orgchart .node .leftEdge {
  left: -4px;
}
.orgchart .node .horizontalEdge::before {
  position: absolute;
  top: calc(50% - 7px);
}
.orgchart .node .rightEdge::before {
  right: 3px;
}
.orgchart .node .leftEdge::before {
  left: 3px;
}
.orgchart .node .toggleBtn {
  position: absolute;
  left: 5px;
  bottom: -2px;
  color: rgba(68, 157, 68, 0.6);
}
.orgchart .node .toggleBtn:hover {
  color: rgba(68, 157, 68, 0.8);
}
.oc-export-btn {
  width: 76px;
  height: 34px;
  padding-top: -20px;
  top: 0px;
/* //   display: inline-block; */
  position: absolute;
/* //   right: 5px;
//   top: 5px;
  // padding: 6px 12px;
//   margin-bottom: 0;
//   font-size: 14px;
//   font-weight: 400;
//   line-height: 1.42857143;
//   text-align: center;
//   white-space: nowrap;
//   vertical-align: middle;
//   touch-action: manipulation;
//   cursor: pointer;
//   user-select: none;
//   color: #fff;
//   background-color: #5cb85c;
//   border: 1px solid transparent;
//   border-color: #4cae4c;
//   border-radius: 4px; */
}
/* // .oc-export-btn[disabled] {
//   cursor: not-allowed;
//   box-shadow: none;
//   opacity: 0.3;
// }
// .oc-export-btn:hover,
// .oc-export-btn:focus,
// .oc-export-btn:active {
//   background-color: #449d44;
//   border-color: #347a34;
// } */
.orgchart ~ .mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
.orgchart ~ .mask .spinner {
  position: absolute;
  top: calc(50% - 54px);
  left: calc(50% - 54px);
  color: rgba(255, 255, 255, 0.8);
  font-size: 108px;
}
.orgchart .node {
  transition: transform 0.3s, opacity 0.3s;
}
.orgchart .slide-down {
  opacity: 0;
  transform: translateY(40px);
}
.orgchart.l2r .node.slide-down,
.orgchart.r2l .node.slide-down {
  transform: translateY(130px);
}
.orgchart .slide-up {
  opacity: 0;
  transform: translateY(-40px);
}
.orgchart.l2r .node.slide-up,
.orgchart.r2l .node.slide-up {
  transform: translateY(-130px);
}
.orgchart .slide-right {
  opacity: 0;
  transform: translateX(130px);
}
.orgchart.l2r .node.slide-right,
.orgchart.r2l .node.slide-right {
  transform: translateX(40px);
}
.orgchart .slide-left {
  opacity: 0;
  transform: translateX(-130px);
}
.orgchart.l2r .node.slide-left,
.orgchart.r2l .node.slide-left {
  transform: translateX(-40px);
}
</style>
